import React from "react";
import { TextField } from "@mui/material";

const IntegerEditCell = ({ value, onValueChange,  noPadding = false, }) => { // noPadding Props
  const [localValue, setLocalValue] = React.useState(
    value === null || value === undefined ? "" : Number(value)
  );

  // Sync with external value (e.g. after reload)
  React.useEffect(() => {
    setLocalValue(
      value === null || value === undefined ? "" : Number(value)
    );
  }, [value]);


  const handleFocus = () => {
    // Clear UI only (do not touch parent state here)
    setLocalValue("");
  };

  const handleChange = (event) => {
    // Allow only digits visually
    const onlyDigits = event.target.value.replace(/\D/g, "");
    setLocalValue(onlyDigits);

     if (onlyDigits === "") {
    setLocalValue("0");
    onValueChange(0);
    return;
  }

    // Immediately push numeric value to parent to mark row as edited
    if (onlyDigits !== "") {
      const num = Number(onlyDigits);
      if (Number.isFinite(num)) {
        onValueChange(num); // this sets IsRowEdited = true in parent
      }
    }
  };

  const handleBlur = () => {
    // On blur: if empty -> 0, else keep number
    const raw = localValue;
    const num = raw === "" ? 0 : Number(raw);
    const finalValue = Number.isFinite(num) ? num : 0;

    setLocalValue(String(finalValue)); // normalize in UI
    onValueChange(finalValue);         // ensure parent has final value (0 if empty)
  };

    const handleKeyDown = (e) => {
      const blocked = [
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End",
        "PageUp",
        "PageDown",
      ];
      if (blocked.includes(e.key)) e.stopPropagation();
      if (e.key === " ") e.stopPropagation();
    };

  return (
    <TextField
      fullWidth
      value={localValue}
      // onFocus={handleFocus}
      onChange={handleChange}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      type="text" // text, so no spinner arrows
       autoComplete="off"
      // inputProps={{
      //   inputMode: "numeric",
      //   pattern: "[0-9]*",
      //   style: { padding: "2px 4px" },
      // }}
       inputProps={{
        inputMode: "numeric",
        pattern: "[0-9]*",
        style: {
          padding: noPadding ? "8px 4px" : "2px 4px", // ✅ CONDITIONAL
          height: "100%",
        },
      }}
      
    />
  );
};

export default IntegerEditCell;
